module.exports = __webpack_public_path__ + "preview-9a17d32fc48369e8ccd910a75260e67d.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/preview.jpg
// module id = 195
// module chunks = 65